import request from "./request";

const api = {
  getTokenTop: "token/getTokenTop",
  getTokenList: "token/getTokenList",
  buyToken: "token/buyToken",
};
export default {
  buyToken(parameter) {
    return request({
      url: api.buyToken,
      method: "POST",
      data: parameter,
    });
  },
  getTokenTop(parameter) {
    return request({
      url: api.getTokenTop,
      method: "POST",
      data: parameter,
    });
  },
  getTokenList(parameter) {
    return request({
      url: api.getTokenList,
      method: "POST",
      data: parameter,
    });
  },
};
